import React, { useEffect, useRef } from "react";
import Grid from "@mui/material/Grid";
import Typography from "@mui/material/Typography";
import FloatLabel from "../../UiComponents/FloatLabel/FloatLabel";
import { Formik, Form, Field } from "formik";
import {
  base64toBlob,
  downloadFileBase64ByKey,
  PostBranch,
  UpdateBranch,
} from "../../Service/_index";
import CloseIcon from "@mui/icons-material/Close";
import { FileUploader } from "react-drag-drop-files";
import Button from "@mui/material/Button";
import { Autocomplete, Box, TextField, Tooltip } from "@mui/material";
import Styles from "./User.module.scss";
import { RemoveRedEyeIcon } from "../../Resources/Icons/icons";
import Loader from "../../UiComponents/Loader/Loader";
import {
  getAllBankDetails,
  updateBankDetailsByUserId,
} from "../../Service/UserService";
import { AWS_DIRECTORY_NAME } from "../../Shared/CommonConstant";

const AddBankDrawer = (props) => {
  const {
    id,
    selectedBankData,
    formType,
    setOpenAddBankDrawer,
    title,
    GetActiveData,
    newValue,
  } = props;
  let formRef = useRef();

  const initialValues = {
    bankAccountHolderName: "",
    accountNumber: "",
    bankName: "",
    bankBranch: "",
    ifscCode: "",
    micrNumber: "",
    panNumber: "",
    aadharNumber: "",
    gstNumber: "",
    tds: "",
    PANCardProof: "",
    PassBookProof: "",
    AadharProof: "",
    GSTProof: "",
  };
  const UserId = sessionStorage.getItem("UserId");
  const [openLoader, setOpenLoader] = React.useState(false);
  const [allBankDetails, setAllBankDetails] = React.useState([]);
  const [selectedAccNo, setSelectedAccNo] = React.useState("");

  useEffect(() => {
    if (formType === "edit") {
      Object.keys(initialValues).forEach((el) => {
        initialValues[el] = selectedBankData.values[el];
      });
    }
    formRef.setFieldValue(initialValues);
    getAllBankDetailsFunc();
  }, []);

  const setBankDetails = (bankData) => {
    if (!bankData) return true;
    // console.log("bankData :::", bankData);
    selectedBankData.values = bankData;
    Object.keys(initialValues).forEach((key) => {
      // initialValues[el] = bankData[el];
      // let key = e1;
      // let value = bankData[e1];
      // formRef.setFieldValue(key, value);

      const value = bankData[key];
      initialValues[key] = value; // Only works if initialValues is not a const
      formRef.setFieldValue(key, value);
    });
    console.log("initialValues :::", initialValues);
    // formRef.setFieldValue(initialValues);
  };

  const getAllBankDetailsFunc = () => {
    getAllBankDetails().then((res) => {
      console.log("getAllBankDetails : ", res);
      const ModifiedDetails = res?.data?.bankDetails.map((e) => {
        return {
          ...e,
          label: e.accountNumber + " - " + e.bankAccountHolderName,
          value: e.accountNumber,
        };
      });
      setAllBankDetails(ModifiedDetails || []);
    });
  };

  const downloadFile = (key) => {
    setOpenLoader(true);
    downloadFileBase64ByKey(key)
      .then((res) => {
        // console.log("res : ", res);
        const downloadURL = res?.data?.downloadURL || "";
        // window.open(downloadURL);
        const blobData = base64toBlob(downloadURL, "image/png");
        const blobUrl = URL.createObjectURL(blobData);
        // setOpenLoader(false);
        const imageWindow = window.open("", "_blank");
        imageWindow?.document?.write(
          // `<embed src="data:application/pdf;base64,${pdfUrl}" width="100%" height="100%" />`
          `<embed src="${blobUrl}" width="100%" height="100%" />`
        );
      })
      .finally(() => setOpenLoader(false));
  };

  // const onSubmit = (e) => {
  //   setOpenAddBankDrawer(false);
  //   const index = selectedBankData.index;
  //   newValue({ index, e });
  // };

  const onSubmit = (e) => {
    let index = selectedBankData.index;
    // newValue({ index, e });
    console.log("e ", e);
    console.log("selectedBankData ", selectedBankData);
    const selectedRow = selectedBankData.values;
    const updatedData = {};
    Object.keys(e).forEach((key) => {
      if (selectedRow && e[key] != selectedRow[key]) {
        updatedData[key] = e[key];
      } else {
        updatedData[key] = e[key];
      }
    });
    // console.log("index : ", index);
    let formData = new FormData();
    for (var key in updatedData) {
      formData.append(key, updatedData[key]);
    }
    if (updatedData[AWS_DIRECTORY_NAME.AWS__PAN_CARD_DIRECTORY_NAME]) {
      formData.append(
        AWS_DIRECTORY_NAME.AWS__PAN_CARD_DIRECTORY_NAME,
        updatedData[AWS_DIRECTORY_NAME.AWS__PAN_CARD_DIRECTORY_NAME]
      );
    }
    if (updatedData[AWS_DIRECTORY_NAME.AWS_BANK_BOOK_DIRECTORY_NAME]) {
      formData.append(
        AWS_DIRECTORY_NAME.AWS_BANK_BOOK_DIRECTORY_NAME,
        updatedData[AWS_DIRECTORY_NAME.AWS_BANK_BOOK_DIRECTORY_NAME]
      );
    }
    if (updatedData[AWS_DIRECTORY_NAME.AWS_AADHAR_PROOF_DIRECTORY_NAME]) {
      formData.append(
        AWS_DIRECTORY_NAME.AWS_AADHAR_PROOF_DIRECTORY_NAME,
        updatedData[AWS_DIRECTORY_NAME.AWS_AADHAR_PROOF_DIRECTORY_NAME]
      );
    }
    // return true;
    console.log("updatedData ", updatedData);
    if (updatedData) {
      formData.append("index", index);
      setOpenLoader(true);
      updateBankDetailsByUserId(id, formData)
        .then((res) => {
          // console.log("res ", res);
          const bankDetails = res?.data?.bankDetails || [];
          index = index != "undefined" ? bankDetails.length - 1 : index;
          const updatedData = bankDetails[index];
          console.log("updatedData ", updatedData);
          newValue({ index: index, e: updatedData });
          setOpenAddBankDrawer(false);
        })
        .catch((error) => {
          console.log(error);
        })
        .finally(() => {
          setOpenLoader(false);
        });
    } else {
      setOpenAddBankDrawer(false);
    }
  };

  console.log(selectedBankData);
  return (
    <>
      <Box className="DrawerContainer">
        <Grid container className="DrawerHeader">
          <Grid item xs={6} sm={6}>
            <Typography className="DrawerTitle">{title} Bank Detail</Typography>
          </Grid>
          <Grid item xs={6} sm={6} className="d-flex justify-content-end">
            <CloseIcon
              onClick={() => setOpenAddBankDrawer(false)}
              sx={{
                cursor: "pointer",
                height: "18px",
                width: "18px",
                fontWeight: 600,
              }}
            />
          </Grid>
        </Grid>

        <Formik
          initialValues={initialValues}
          onSubmit={(values) => {
            onSubmit(values);
          }}
          innerRef={(ref) => {
            if (ref) {
              formRef = ref;
            }
          }}
        >
          {({ values, setFieldValue }) => (
            <Form>
              <div className={Styles.addContent}>
                <Grid container spacing={2}>
                  <Grid item xs={12} sm={12}>
                    <FloatLabel label="Select Account" value={selectedAccNo}>
                      <Autocomplete
                        className="AutoComplete_InputBox"
                        options={allBankDetails}
                        onChange={
                          (option, value) => {
                            console.log(
                              "option ::",
                              option,
                              "value  ::",
                              value
                            );
                            setSelectedAccNo(value?.accountNumber);
                            setBankDetails(value);
                          }
                          // setFilterBy({
                          //   ...filterBy,
                          //   subProductId: value?._id,
                          //   productId: value?.productID,
                          // })
                        }
                        renderInput={(params) => <TextField {...params} />}
                        isOptionEqualToValue={(option, value) =>
                          option.accountNumber === value.accountNumber
                        }
                        // key={resetValue}
                      />
                    </FloatLabel>
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Account Holder Name"
                        value={values.bankAccountHolderName}
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Account Holder Name
                    </Typography>
                    <Field
                      name="bankAccountHolderName"
                      className="InputFiled"
                      placeholder="Enter Account Holder Name"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Account Number"
                        value={values.accountNumber}
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Account Number
                    </Typography>
                    <Field
                      name="accountNumber"
                      className="InputFiled"
                      placeholder="Enter Account Number"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Bank Name" value={values.bankName}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Bank Name
                    </Typography>
                    <Field
                      name="bankName"
                      className="InputFiled"
                      placeholder="Enter Bank Name"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Bank Branch" value={values.bankBranch}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Bank Branch
                    </Typography>
                    <Field
                      name="bankBranch"
                      placeholder="Enter Bank Branch"
                      className="InputFiled"
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Ifsc Code" value={values.ifscCode}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      IFSC Code
                    </Typography>
                    <Field
                      name="ifscCode"
                      className="InputFiled"
                      placeholder="Enter IFSC Code"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Micr Number" value={values.micrNumber}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      MIRC Number
                    </Typography>
                    <Field
                      name="micrNumber"
                      className="InputFiled"
                      placeholder="Enter MIRC Number"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>{" "}
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="Pan Number" value={values.panNumber}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Pan Number
                    </Typography>
                    <Field
                      name="panNumber"
                      className="InputFiled"
                      placeholder="Enter Pan Number"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>{" "}
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel
                        label="Adhar Number"
                        value={values.aadharNumber}
                      > */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      Aadhar Number
                    </Typography>
                    <Field
                      name="aadharNumber"
                      className="InputFiled"
                      placeholder="Enter Aadhar Number"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>{" "}
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="GST Number" value={values.gstNumber}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      GST Number
                    </Typography>
                    <Field
                      name="gstNumber"
                      className="InputFiled"
                      placeholder="Enter GST Number"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  <Grid item xs={12} sm={6}>
                    {/* <FloatLabel label="TDS Percentage" value={values.tds}> */}
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      TDS Percentage
                    </Typography>
                    <Field
                      name="tds"
                      className="InputFiled"
                      placeholder="Enter TDS Percentage"
                      // style={{ textTransform: "uppercase" }}
                    />
                    {/* </FloatLabel> */}
                  </Grid>
                  {/* <Grid item xs={12} sm={6}>
                    <Typography
                      className={Styles.inputTitle}
                      sx={{ fontSize: "12px", mb: 1 }}
                    >
                      ID Proof
                    </Typography>
                    <div className="File-Upload">
                      <FileUploader
                        handleChange={(e) => setFieldValue("idProof", e)}
                        name="idProof"
                        label="Upload Your ID Proof"
                        dropMessageStyle={{
                          color: "red",
                          border: "none",
                          borderRadius: "0px",
                        }}
                      />
                    </div>
                  </Grid> */}
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className="File-Upload"
                    style={{
                      display: values.PANCardProof ? "flex" : "block",
                      "align-items": "center",
                    }}
                  >
                    <FileUploader
                      handleChange={(e) => setFieldValue("PANCardProof", e)}
                      name="PANCardProof"
                      label={
                        values?.PANCardProof?.key
                          ? "PAN Card uploaded, Upload another?"
                          : "Upload Your PAN Card"
                      }
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                    />
                    <Tooltip title="view">
                      <RemoveRedEyeIcon
                        sx={{
                          display: values.PANCardProof ? "block" : "none",
                          cursor: "pointer",
                        }}
                        onClick={() => downloadFile(values.PANCardProof.key)}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className="File-Upload"
                    style={{
                      display: values.PassBookProof ? "flex" : "block",
                      "align-items": "center",
                    }}
                  >
                    <FileUploader
                      handleChange={(e) => setFieldValue("PassBookProof", e)}
                      name="PassBookProof"
                      label={
                        values?.PassBookProof?.key
                          ? "Passbook uploaded, Upload another?"
                          : "Upload Your Passbook / Cheque"
                      }
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                    />
                    <Tooltip title="view">
                      <RemoveRedEyeIcon
                        sx={{
                          display: values?.PassBookProof?.key
                            ? "block"
                            : "none",
                          cursor: "pointer",
                        }}
                        onClick={() => downloadFile(values.PassBookProof.key)}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className="File-Upload"
                    style={{
                      display: values.AadharProof ? "flex" : "block",
                      "align-items": "center",
                    }}
                  >
                    <FileUploader
                      handleChange={(e) => setFieldValue("AadharProof", e)}
                      name="AadharProof"
                      label={
                        values?.AadharProof?.key
                          ? "Aadhar uploaded, Upload another?"
                          : "Upload Your Aadhar"
                      }
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                    />
                    <Tooltip title="view">
                      <RemoveRedEyeIcon
                        sx={{
                          display: values?.AadharProof?.key ? "block" : "none",
                          cursor: "pointer",
                        }}
                        onClick={() => downloadFile(values.AadharProof.key)}
                      />
                    </Tooltip>
                  </Grid>
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    className="File-Upload"
                    style={{
                      display: values.GSTProof ? "flex" : "block",
                      "align-items": "center",
                    }}
                  >
                    <FileUploader
                      handleChange={(e) => setFieldValue("GSTProof", e)}
                      name="GSTProof"
                      label={
                        values?.GSTProof?.key
                          ? "GST uploaded, Upload another?"
                          : "Upload Your GST"
                      }
                      dropMessageStyle={{
                        color: "red",
                        border: "none",
                        borderRadius: "0px",
                      }}
                    />
                    <Tooltip title="view">
                      <RemoveRedEyeIcon
                        sx={{
                          display: values?.GSTProof?.key ? "block" : "none",
                          cursor: "pointer",
                        }}
                        onClick={() => downloadFile(values.GSTProof.key)}
                      />
                    </Tooltip>
                  </Grid>
                  {/* <Grid className="Dialog_Footer" item xs={12} sm={6} gap={1}>
                    <button onClick={() => setOpenAddBankDrawer(false)}>
                      Cancel
                    </button>
                    <button type="submit" >
                      
                    </button>
                  </Grid> */}
                </Grid>
              </div>
              <div className="Dialog_Footer">
                <Button
                  onClick={() => setOpenAddBankDrawer(false)}
                  className="Dialog_Cancel"
                >
                  Cancel
                </Button>
                <Button className="Dialog_Save_Exit" type="submit">
                  {selectedBankData?.values ? "Update" : "Add New Bank"}
                </Button>
              </div>
            </Form>
          )}
        </Formik>
      </Box>
      <Loader open={openLoader} />
    </>
  );
};

export default AddBankDrawer;
